<template>
  <v-card>
    <v-toolbar
      flat
      color="primary"
      dark
    >
      <v-toolbar-title>Send a message to the team</v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-text-field
        filled
        label="Title"
      />

      <v-textarea
        filled
        label="Text"
      />

      <v-divider class="my-2" />

      <v-item-group multiple>
        <v-subheader>Tags</v-subheader>
        <v-item
          v-for="tag in tags"
          :key="tag"
          v-slot="{ active, toggle }"
        >
          <v-chip
            active-class="secondary"
            :input-value="active"
            @click="toggle"
          >
            {{ tag }}
          </v-chip>
        </v-item>
      </v-item-group>
    </v-card-text>

    <v-divider />

    <v-card-actions>
      <v-spacer />
      <v-btn
        color="success"
        depressed
      >
        Post
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    data: () => ({
      length: 3,
      window: 0,
      tags: ['Training', 'Match', 'Opportunity', 'Personal', 'MANDATORY', 'Learning'],
    }),
  }
</script>
